module.exports = __webpack_public_path__ + "static/media/re.678ffd1c.png";